const DynamicDetails = require('./dp').DynamicDetails;
const collectMovement = require('./dp').collectMovement;
const Fingerprint2 = require('fingerprintjs2');

function readLocalStorage() {
  return new Promise(resolve => {

  })
}

module.exports.init = function() {
  let details = new DynamicDetails();
  try {
    let k = localStorage.getItem('gwdang-dfp-obj')
    let r = JSON.parse(k)
    Object.keys(r).forEach(item => {
      details[item] = r[item]
    })
  } catch (e) {

  }
  if (window.requestIdleCallback) {
    requestIdleCallback(() => {
      collectMovement(details)
    })
  } else {
    setTimeout(() => {
      collectMovement(details)
    }, 500)
  }

  let fp = '';
  Fingerprint2.get({
    fonts: {
      extendedJsFonts: false
    },
    excludes: {
      userAgent: true,
      enumerateDevices: true,
      pixelRatio: true,
      doNotTrack: true,
      fontsFlash: true
    }
  }, components => {
    const values = components.map(component => component.value);
    const murmur = Fingerprint2.x64hash128(values.join(''), 31)
    fp = murmur
    // communicate.trigger({
    //   type: 'fp',
    //   value: fp
    // })
    document.cookie = 'fp=' + fp + ';path=/';
    localStorage.setItem('gwdang-fp', fp)
  })

  let k = setInterval(() => {
    let collected = details.encode()
    localStorage.setItem('gwdang-dfp-obj', JSON.stringify(details))
    // communicate.trigger({
    //   type: 'fingerprint',
    //   value: collected
    // })
    document.cookie = 'dfp=' + collected  + ';path=/';
    localStorage.setItem('gwdang-dfp', collected)
  }, 2000)

  setTimeout(() => {
    clearInterval(k)
  }, 300000)
}